import './Page.css'
import './Donate.css'

function Donate() {
  return (
    <div className="page-container">
      <div className="donate-header">
        <h1>Support Alchemy Forum</h1>
        <p>
          Alchemy Forum is an independent, community‑run platform. Hosting, storage for
          large files, and the time it takes to build and maintain the platform all have
          real costs.
        </p>
        <p>
          If this platform is useful to you&mdash;whether you&apos;re a repair tech,
          builder, researcher, or just someone who loves electronics and circuits&mdash;consider
          supporting its ongoing development. Even small recurring contributions help keep
          the lights on and the roadmap moving.
        </p>
      </div>

      <div className="donate-content">
        <div className="donate-list-section">
          <h2 className="donate-list-title">How your support helps</h2>
          <ul className="donate-list">
            <li>Hosting and bandwidth for schematics and documentation.</li>
            <li>Reliable backups, monitoring, and security tooling.</li>
            <li>Design and engineering time to ship new features.</li>
            <li>Community moderation and documentation improvements.</li>
          </ul>
          <p className="donate-footer">
            If you believe in open source, right to repair, and keeping technology alive, any amount greatly helps. <span className="donate-footer-bold">Thank you in advance.</span>
          </p>
        </div>

        <div className="donate-form-section">
          <div className="donate-preview">
            <div className="donate-preview-wire donate-preview-wire-left wire-a">
              <div className="wire-path wire-path-horizontal" />
              <div className="wire-path wire-path-vertical" />
              <div className="wire-node" />
            </div>
            <div className="donate-preview-wire donate-preview-wire-left wire-b">
              <div className="wire-path wire-path-horizontal" />
              <div className="wire-path wire-path-vertical" />
              <div className="wire-node" />
            </div>
            <div className="donate-preview-wire donate-preview-wire-right wire-c">
              <div className="wire-path wire-path-horizontal" />
              <div className="wire-path wire-path-vertical" />
              <div className="wire-node" />
            </div>
            <div className="preview-content">
              {/* Decorative Schematic Elements */}
              <svg className="schematic-decoration" viewBox="0 0 400 300" preserveAspectRatio="none">
                {/* Circuit traces around the form */}
                <g className="component trace trace-1">
                  <path d="M0 50 Q 100 30, 200 50 T 400 50" fill="none" stroke="currentColor" strokeWidth="1.5" opacity="0.3"/>
                </g>
                <g className="component trace trace-2">
                  <path d="M0 250 Q 100 270, 200 250 T 400 250" fill="none" stroke="currentColor" strokeWidth="1.5" opacity="0.3"/>
                </g>
              </svg>

              {/* Donate Form */}
              <div className="donate-form-container">
                <div className="donate-form">
                  <p className="donate-footer">
                    Donations are handled securely through PayPal. You&apos;ll be redirected to
                    PayPal to complete your contribution.
                  </p>
                  <a
                    href="https://www.paypal.com/donate/?hosted_button_id=9FB5NJVKV3WT4"
                    className="donate-submit-btn"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <svg
                      aria-hidden="true"
                      focusable="false"
                      viewBox="0 0 24 24"
                    >
                      <defs>
                        <linearGradient id="paypalGradient" x1="0" y1="0" x2="1" y2="1">
                          <stop offset="0%" stopColor="#003087" />
                          <stop offset="100%" stopColor="#009cde" />
                        </linearGradient>
                      </defs>
                      <path
                        fill="url(#paypalGradient)"
                        d="M9.5 4.2C10.3 3.5 11.4 3 12.9 3h3.1c1.9 0 3.3.7 4 1.9.6 1 .7 2.4.3 3.8-.7 2.7-2.9 4.4-5.8 4.4h-1.3l-.6 3.7c-.1.7-.6 1.2-1.3 1.2H8.3c-.5 0-.9-.4-.8-.9l1.5-9.8c.1-.8.5-1.5 1-1.9z"
                      />
                      <path
                        fill="#001c64"
                        d="M7.2 5.6C8 4.9 9.1 4.4 10.6 4.4h3.1c1.3 0 2.3.3 3.1.9-.6-.2-1.3-.3-2-.3h-3.1c-1.5 0-2.6.5-3.4 1.2-.5.4-.9 1.1-1 1.9l-1.5 9.8c-.1.4.3.9.8.9H8l-1.3.1c-.5 0-.9-.4-.8-.9l1.5-9.8c.1-.8.5-1.5.8-1.9z"
                      />
                    </svg>
                    <span>Donate with PayPal</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Donate

